import {Request} from "../core/request";
import {AuthHeader} from "../core/token";
import {
    apiAdminParseWordToQuestionListResponse,
    apiUserTeacherPapersResp,
    CreateUpdatePaperTaskRequest,
    TeacherAnswer,
    TeacherExamPaper,
    TeacherExamPaperTask,
    TeacherQuestion,
    TeacherQuestionBank,
    TeacherBankStat,
    TeacherWithAnswerRecord
} from "./types";


// todo 补充数据类型

// --- 普通用户接口
export async function apiUserTeacherPapers(): Promise<apiUserTeacherPapersResp> {
    const resp = await Request.get(`/teacher/teacher_assessment/papers`, {headers: AuthHeader()})
    return resp.data;
}

export async function apiUserTeacherRunningPaper(): Promise<{
    Answer:TeacherAnswer,
    Paper: TeacherExamPaper,
    message: string,
    run: boolean,
}> {
    const resp = await Request.get(`/teacher/teacher_assessment/paper/running`, {headers: AuthHeader()})
    return resp.data
}

export async function apiUserTeacherPaperDetail(paperId: number): Promise<{
    Answer:TeacherAnswer,
    Paper: TeacherExamPaper,
}> {
    const resp = await Request.get(`/teacher/teacher_assessment/paper/${paperId}`, {headers: AuthHeader()})
    return resp.data
}

export async function apiUserTeacherStartPaperAnswer(paperId: number) : Promise<TeacherAnswer> {
    const resp = await Request.post(`/teacher/teacher_assessment/paper/${paperId}/answer/start`,{}, {headers: AuthHeader()})
    return resp.data
}

export async function apiUserTeacherCachePaperAnswer(paperId: number, data: any) {
    const resp = await Request.post(`/teacher/teacher_assessment/paper/${paperId}/answer/cache`, {message: data}, {headers: AuthHeader()})
    return  resp.data
}

export async function apiUserTeacherEndPaperAnswer(paperId: number, data: any) {
    const resp = await Request.post(`/teacher/teacher_assessment/paper/${paperId}/answer/end`, {message: data}, {headers: AuthHeader()})
    return resp.data
}

// --- 管理员接口
export async function apiAdminParseWordToQuestionList(file: File): Promise<apiAdminParseWordToQuestionListResponse> {
    const formData = new FormData();
    formData.append("upload", file);

    const resp = await Request.post(`/admin_manager/teacher_assessment/parser_docx`, formData, {
        headers: {
            ...AuthHeader(),
            "Content-Type": "multipart/form-data"
        }
    });

    return resp.data
}


// ---- 题库

// 获取题库列表
export async function apiAdminGetQuestionBankList(): Promise<TeacherQuestionBank[]> {
    const resp = await Request.get(`/admin_manager/teacher_assessment/questionBank`, {
        headers: AuthHeader()
    });
    return resp.data
}

// 获取题库详情
export async function apiAdminGetQuestionBankDetail(bankId: number): Promise<TeacherQuestionBank> {
    const resp = await Request.get(`/admin_manager/teacher_assessment/questionBank/${bankId}`, {
        headers: AuthHeader()
    });
    return resp.data;
}

// 创建题库
export async function apiAdminCreateQuestionBank(data: TeacherQuestionBank) {
    return await Request.post(`/admin_manager/teacher_assessment/questionBank`, data, {
        headers: AuthHeader()
    });
}

// 更新题库
export async function apiAdminUpdateQuestionBank(bankId: number, data: TeacherQuestionBank) {
    return await Request.put(`/admin_manager/teacher_assessment/questionBank/${bankId}`, data, {
        headers: AuthHeader()
    });
}

// 删除题库
export async function apiAdminDeleteQuestionBank(bankId: number) {
    return await Request.delete(`/admin_manager/teacher_assessment/questionBank/${bankId}`, {
        headers: AuthHeader()
    });
}

// 获取题库下的题目列表
export async function apiAdminGetQuestionBankQuestions(bankId: number): Promise<TeacherQuestion[]> {
    const resp = await Request.get(`/admin_manager/teacher_assessment/questionBank/${bankId}/questions`, {
        headers: AuthHeader()
    });
    return resp.data
}

// 添加题目
export async function apiAdminAddQuestionsToBank(bankId: number, questions: TeacherQuestion) {
    console.log(questions);

    return await Request.post(`/admin_manager/teacher_assessment/questionBank/${bankId}/questions`, questions, {
        headers: AuthHeader()
    });
}

// 更新题库中的题目
export async function apiAdminUpdateQuestionInBank(bankId: number, questionId: number, data: TeacherQuestion) {
    return await Request.put(`/admin_manager/teacher_assessment/questionBank/${bankId}/questions/${questionId}`, data, {
        headers: AuthHeader()
    });
}

// 删除题库中的题目
export async function apiAdminDeleteQuestionFromBank(bankId: number, questionId: number) {
    return await Request.delete(`/admin_manager/teacher_assessment/questionBank/${bankId}/questions/${questionId}`, {
        headers: AuthHeader()
    });
}

// 获取题库统计信息（每道题得分情况）
export async function apiAdminGetQuestionBankStats(bankId: number) {
    return await Request.get(`/admin_manager/teacher_assessment/questionBank/${bankId}/stat`, {
        headers: AuthHeader()
    });
}

// ---- 考试

// 获取考试任务列表
export async function apiAdminGetPaperTaskList(): Promise<TeacherExamPaperTask[]> {
    const resp = await Request.get(`/admin_manager/teacher_assessment/paperTask`, {
        headers: AuthHeader()
    });
    return resp.data
}

// 获取考试任务详情
export async function apiAdminGetPaperTaskDetail(taskId: number) {
    const resp = await Request.get(`/admin_manager/teacher_assessment/paperTask/${taskId}`, {
        headers: AuthHeader()
    });
    return resp.data
}

// 创建考试任务
export async function apiAdminCreatePaperTask(data: CreateUpdatePaperTaskRequest): Promise<{
    message: string;
    id: number;
    shareUrl: string;
}> {
    const resp = await Request.post(`/admin_manager/teacher_assessment/paperTask`, data, {
        headers: AuthHeader()
    });
    return resp.data
}

// 获取考试任务分享链接
export async function apiAdminGetPaperTaskShareLink(taskId: number): Promise<{ taskId: number; shareUrl: string }> {
    const resp = await Request.get(`/admin_manager/teacher_assessment/paperTask/${taskId}/share`, {
        headers: AuthHeader()
    });
    return resp.data
}

// 获取有答题记录的老师列表
export async function apiAdminGetTeachersWithAnswers(): Promise<TeacherWithAnswerRecord[]> {
    const resp = await Request.get(`/admin_manager/teacher_assessment/teacher/answered`, {
        headers: AuthHeader()
    });
    return resp.data
}

// 获取单个老师各题库答题正确比例
export async function apiAdminGetTeacherBankStats(teacherId: number): Promise<TeacherBankStat[]> {
    const resp = await Request.get(`/admin_manager/teacher_assessment/teacher/${teacherId}/bankStats`, {
        headers: AuthHeader()
    });
    return resp.data
}

// 更新考试任务
export async function apiAdminUpdatePaperTask(taskId: number, data: CreateUpdatePaperTaskRequest) {
    const resp = await Request.put(`/admin_manager/teacher_assessment/paperTask/${taskId}`, data, {
        headers: AuthHeader()
    });
    return resp.data
}

// 删除考试任务
export async function apiAdminDeletePaperTask(taskId: number) {
    const resp = await Request.delete(`/admin_manager/teacher_assessment/paperTask/${taskId}`, {
        headers: AuthHeader()
    });
    return resp.data
}

// 立即下发考试
export async function apiAdminTriggerImmediateExam(taskId: number) {
    const resp = await Request.post(`/admin_manager/teacher_assessment/paperTask/${taskId}/next`, {}, {
        headers: AuthHeader()
    });
    return resp.data
}

// 获取任务下的试卷列表
export async function apiAdminGetPaperTaskPapers(taskId: number) {
    const resp = await Request.get(`/admin_manager/teacher_assessment/paperTask/${taskId}/papers`, {
        headers: AuthHeader()
    });
    return resp.data
}

// 获取任务统计信息（所有人的成绩状况）
export async function apiAdminGetPaperTaskStats(paperID: number): Promise<{
    answers:TeacherAnswer[],
    paper: TeacherExamPaper,
}> {
    const resp = await Request.get(`/admin_manager/teacher_assessment/paperTask/paper/${paperID}/stat`, {
        headers: AuthHeader()
    });
    return resp.data
}

// 获取试卷详情（包括每个人考核情况）
export async function apiAdminGetPaperDetailWithStatus(paperId: number) {
    const resp = await Request.get(`/admin_manager/teacher_assessment/papers/${paperId}`, {
        headers: AuthHeader()
    });
    return resp.data
}

// 结束本次试卷考核
export async function apiAdminFinishPaperAssessment(paperId: number) {
    const resp = await Request.post(`/admin_manager/teacher_assessment/papers/${paperId}/done`, {}, {
        headers: AuthHeader()
    });
    return resp.data
}
